<script>
	import {
		Button,
		Modal,
		ModalBody,
		ModalFooter,
		ModalHeader,
	} from "@sveltestrap/sveltestrap";

	export let isOpen = false;
	export let toggle = () => {};
</script>

<Modal {isOpen} {toggle} centered>
	<ModalHeader {toggle}>Unable to cancel work order</ModalHeader>
	<ModalBody class="my-3">
		<p class="mb-2">Work orders can only be cancelled when:</p>
		<ul class="cancel-blocked-list">
			<li>All issues are moved to another work order or backlog</li>
			<li>All jobs are completed or cancelled</li>
		</ul>
	</ModalBody>
	<ModalFooter>
		<Button class="themeButton primary" on:click={toggle}>Back</Button>
	</ModalFooter>
</Modal>

<style>
	.cancel-blocked-list {
		margin: 0;
		padding-left: 20px;
	}
</style>
